import React from 'react';
import {
  GLOBAL_ERROR_TYPES,
  reportGlobalFrontendError,
} from '../utils/globalErrorTelemetry';

const reloadCurrentPage = () => {
  if (typeof window !== 'undefined') window.location.reload();
};

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, errorInfo) {
    try {
      const reportError = this.props.reportError || reportGlobalFrontendError;
      reportError(GLOBAL_ERROR_TYPES.react, error, {
        componentStack: errorInfo?.componentStack || '',
      });
    } catch {
      // O fallback precisa permanecer utilizavel mesmo se a telemetria falhar.
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <main
        role="alert"
        style={{
          alignItems: 'center',
          background: '#fff7ed',
          boxSizing: 'border-box',
          color: '#431407',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        <section style={{ maxWidth: '520px' }}>
          <h1 style={{ fontSize: '1.5rem', margin: '0 0 12px' }}>
            Não foi possível exibir esta tela
          </h1>
          <p style={{ lineHeight: 1.5, margin: '0 0 20px' }}>
            Recarregue a página para continuar. Se o problema voltar, informe o suporte.
          </p>
          <button
            type="button"
            onClick={this.props.onReload || reloadCurrentPage}
            style={{
              background: '#ea580c',
              border: 0,
              borderRadius: '8px',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 700,
              padding: '12px 18px',
            }}
          >
            Recarregar página
          </button>
        </section>
      </main>
    );
  }
}

export default GlobalErrorBoundary;
